import type { GlobalState } from '../types';
import { DEFAULT_FORENSIC_SETTINGS } from '../types/sharedState';
import { selectSharedSettings } from './sharedState';

export function selectForensicSettings<T extends GlobalState>(global: T) {
  return {
    ...DEFAULT_FORENSIC_SETTINGS,
    ...selectSharedSettings(global).forensic,
  };
}
